import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { currentWidget, requestOTP, validateOTP } from '../../action/action'
import { setGoHome, setLoader } from '../../layout2.0/action/homeAction'
import { getDefaultAnalyticsLabel } from '../../layout2.0/JS/utility'
import { sendAnalytics } from "../../action/homeAction"
import SuccessFailScreen from '../../layout2.0/UI/SuccessFailScreen'
import OtpResult from './otpResult'
import { CMSPath } from '../../config/constant'
import { withTranslation } from 'react-i18next'

import OTPInput from 'react-otp-input'
import OtpInputBox from '../../layout2.0/components/utils/otpInputBox'

let noOfAttemptsOTPVerification = 0;

function OtpValidation(props) {
	const {t}=props;
    const [otpSent, setOTPSent] = useState(false)
    const [result, setResult] = useState(false)
    const [showResult, setShowResult] = useState(false)
	const [otp, setOTP] = useState(null)
	const [showFailScreen, setShowFailScreen] = useState({show: false, statusMessage1: "", statusMessage2: ""})
	const [otpMessage, setOTPMessage] = useState("Activate your room key by entering the one-time pin we just sent to your e-mail address.")
	let token = localStorage.getItem("GuestJourneySessionToken")

	const requestOTP = () => {
		setShowFailScreen({show: false, statusMessage1: "", statusMessage2: ""})
		props.setLoader(true, "Sending one-time passcode...", false)
		props.requestOTP(token, props.guestDetail, props.reservationNo, (status, message) => {
			props.setLoader(false, "", false)
			if(status){
				setResult(message)
				setOTPMessage(message)
				setOTPSent(true)
				if(window.device && window.device.platform == "Android"){
					if(window.cordova.plugins.smsRetriever){
						window.cordova.plugins.smsRetriever.startWatching((res) => { console.log("Success retriveing OTP form sms"); autoFillOTP(JSON.stringify(res)) }, (err) => {console.log("Error while auto filling otp " + JSON.stringify(err) )})
					}
				}
			} else {
				//show error with retry
				setOTPSent(false)
				setShowFailScreen({show: true, statusMessage1: "Something went wrong", statusMessage2: message, showTryAgain: true})
				sendGAEvent("OTP VERIFICATION - FAILED", message, () => {}, {"noOfAttempts": noOfAttemptsOTPVerification + 1, displayError: t("doorKey_event_error_messages.APP_OTP_REQUEST_FAILED"), errorCode: "APP_OTP_REQUEST_FAILED"})
				noOfAttemptsOTPVerification = noOfAttemptsOTPVerification + 1;
			}
		})
	}

	const autoFillOTP = (str) => {
		let otpNumber = str.match(/(\d+)/);
		setOTP(otpNumber[0]);
	}

	const sendGAEvent = (action, message, callback, extraLabelInfo) => {
        let label = getDefaultAnalyticsLabel({appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : ""})
        
        props.sendAnalytics(
            props.guestDetail, 
            "Digital Door Key", 
            action, 
            {...label, "layoutTab": props.currentHomePage.tabName, "element": "widget",  "pageName": "OTP VERIFICATION", "errorMessage": message && message, "widgetSessionId": localStorage.getItem("doorKeySessionToken"), ...extraLabelInfo, "pageName": "OTP VALIDATION"},
            0, 
            props.guestIsLoggedIn,
            callback ? callback : false
        );
    }

	const validateOTP = () => {
		props.validateOTP(token, props.guestDetail, props.reservationNo, otp, (status, message) => {
			console.log("OTP validation result", status, message);
			props.setLoader(false, "", false)
			if(status){
				setOTPMessage(message)
				setShowResult(true)
				localStorage.setItem("VerifiedUser", true)
				const dk_otp_verification_success_event_sent = localStorage.getItem("dk_otp_verification_success_event_sent") == "true"
				if(!dk_otp_verification_success_event_sent) sendGAEvent("OTP VERIFICATION - SUCCESS")
			} else {
				//show error with retry
				setShowResult(false)
				setShowFailScreen({show: true, statusMessage1: "Something went wrong", statusMessage2: message})
				sendGAEvent("OTP VERIFICATION - FAILED", message, () => {}, {"noOfAttempts": noOfAttemptsOTPVerification + 1, displayError: t("doorKey_event_error_messages.APP_OTP_VERIFICATION_FAILED"), errorCode: "APP_OTP_VERIFICATION_FAILED"})
				noOfAttemptsOTPVerification = noOfAttemptsOTPVerification + 1;
			}
		})
	}
    useEffect(() => {		
        props.currentWidget({widgetType: true});
		requestOTP()
		const dk_otp_verification_event_sent = localStorage.getItem("dk_otp_verification_event_sent") == "true"
		if(!dk_otp_verification_event_sent) sendGAEvent("OTP VERIFICATION", "", () => {localStorage.setItem("dk_otp_verification_event_sent", true)})

		return () => {
			noOfAttemptsOTPVerification = 0
		}
    },[])
  return (
    <div class="main-container background-overlay">
		<header class="inner-pages subpages no-background  select-door-auth-option-header">
			<a onClick={props.goBack} class="button-back"></a>
			<div class="heading align-center">
				<p class="bold">Door Key</p>
			</div>
		</header>
		<section id="doorLocks" class="widgets padding-bottom-2 margin-0 door-auth-otp-validation">
			<div class="widgets">
				<div class="row">
					<div class="col">
						<div class="unlock-container door-locked">
							<h1 class="align-center">{t("door_key_auth.otp_input_heading") || "Enter OTP" }</h1>
							<p class="heading">{otpMessage}</p>
							<h4 class="heading2">{t("door_key_auth.otp_input_heading2")}</h4>
							<div class="lg-buttons multi no-flex align-center">
								{/* <input disabled={!otpSent}  autoFocus inputMode="numeric" pattern="[0-9]*" type="password" onChange={e => setOTP(e.target.value)} value={otp} name="otp" maxlength="4" /> */}

								<OtpInputBox htmlId={"unique-otp-input"} disabled={!otpSent} value={otp} onChange={(value)=>{setOTP(value)}} allowAutoFill={true} maxlength={props.digitalKeyOtpLength}/>
				
								<button class="button primary" disabled={!otpSent} onClick={validateOTP}>{t("door_key_auth.otp_input_button_validate")|| "Validate OTP"} </button>
								<div class="break" style={{fontSize:"1.25rem"}}>{t("door_key_auth.didnt_receive_your_otp")}</div>
								<button onClick={requestOTP} class="button secondary" >Resend</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
        {
            showResult && <OtpResult cancel={props.goBack} status={result} resendOTP={requestOTP} proceedNext={props.proceedNext} />
        }
		{showFailScreen.show && <SuccessFailScreen statusMessage1={showFailScreen.statusMessage1} statusMessage2={showFailScreen.statusMessage2} showTryAgain={showFailScreen.showTryAgain} showClose={true} tryAgain={requestOTP} close={otpSent ? () => setShowFailScreen({show: false, statusMessage1: "", statusMessage2: ""}) : () => props.setGoHome(true)} />}
    </div>
  )
}

const mapStateToProps = state => {
    return {
		guestDetail: state.store.home.guestDetails,
        reservationNo: state.store.reservationNo,
        CheckedInGuest: state.store.CheckedInGuest,
        installedAppName: state.store.installedAppName,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        loginGuestDetails: state.store2.loginGuestDetails,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidgets: state.store.sideNavBar.currentWidget,
        currentHomePage: state.store2.currentHomePage,
		digitalKeyOtpLength: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.digitalKeyOtpLength,

    }
}

export default connect(mapStateToProps, {currentWidget, setLoader, requestOTP, setGoHome, validateOTP, sendAnalytics})(withTranslation("translations")(OtpValidation))